class Consts {
	constructor() {
		this.APP_NAME = '7Coins';
		this.MSG_CONFIRM_REGISTER = 'データを登録します。よろしいですか？';
		this.MSG_CONFIRM_DELETE = '選択したデータを削除します。よろしいですか？';
		this.TABLE_PER_PAGE = 10;
		this.COMPANY_NAME = '株式会社ほほえみ';
		this.PWD_PH = '半角英数4文字以上';
		this.GOTOTAB_SCHEME = 'gototab:';
		this.DUMMY_TOKEN = 'tokens';
	}
}

export default Consts
